import { DirectoryProperty, DirectoryOccupant } from '@centecomm/portal-service';
import { createSelector } from 'reselect';

import { LoadStatus, State } from '../../Types';

const directoryState = ({ directory }: State) => directory;

// Properties
const propertiesSlice = createSelector(directoryState, ({ properties }) => properties);

export const propertiesLoadStatus = createSelector(propertiesSlice, ({ loadStatus }) => loadStatus);

export const propertiesAreLoaded = createSelector(propertiesLoadStatus, (loadStatus) => loadStatus === LoadStatus.LOADED);

export const properties = createSelector(propertiesSlice, ({ loadStatus, ...rest }) => rest);

export const propertiesList = createSelector(propertiesSlice, ({ loadStatus, errorState, sortOrder, ...rest }) =>
    Object.values(rest),
);

export const sortedPropertiesList = createSelector(
    directoryState,
    ({ properties }): DirectoryProperty[] => properties.sortOrder?.map((i) => properties[i]) || [],
);

export const property = (propertyId: number) =>
    createSelector(propertiesSlice, (properties): DirectoryProperty => properties[propertyId] || {});

// Occupants
export const propertyOccupants = (propertyId: number) =>
    createSelector(propertiesSlice, (properties): DirectoryOccupant[] => properties[propertyId].occupants || []);

export const occupant = (propertyId: number, occupantId: number) =>
    createSelector(propertiesSlice, (properties): DirectoryOccupant | undefined =>
        properties.hasOwnProperty(propertyId) && properties[propertyId].occupants.some((o) => o.id === occupantId)
            ? properties[propertyId].occupants.filter((o) => o.id === occupantId)[0]
            : undefined,
    );
